<script lang="ts" setup>
import {toRefs} from 'vue';
import {useSession} from '/src/core/session';
import GalleryProject from './GalleryProject.vue';
import {Project} from '/src/api/projects';

const session = useSession();
const {state} = session;
const {auth} = toRefs(state);

defineProps<{
    projects: Array<Project & {screens_count: number}>;
}>();
</script>
<template>
    <div class="grid md:grid-cols-3 lg:grid-cols-5 gap-6 mb-8">
        <template
            v-for="project in projects"
            :key="project.id"
        >
            <div
                v-if="project.screens && project.screens[0].img_preview"
                class=""
            >
                <GalleryProject
                    :project="project"
                    :backgroundColor="project.color_bg ?? session.getPlatformFeatures(project.platform).screenBgColor"
                    :isAuthorized="!!auth"
                />
            </div>
        </template>
    </div>
</template>

<style></style>
